import { Navigation } from "../../components/Navigation/navigation";
import './legal.css';
export const Legal = () => {
    return <>
      <Navigation />
      <div id='legal' className='text-center'>
        <div className='container'>
          <div className='section-title'>
            <h2>Legal</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
          </div>
        </div>
      </div>
    </>
}
  